import { render } from "./advance-list-detail.vue?vue&type=template&id=6cf93bec&ts=true"
import script from "./advance-list-detail.vue?vue&type=script&lang=ts"
export * from "./advance-list-detail.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__